module.exports = __webpack_public_path__ + "static/img/db-life-thumb.ce0b524.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/db-life-thumb.jpg
// module id = K5zM
// module chunks = 0